import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as data from "../../../../../assets/img/success_lottie_shade.json";
@Component({
  selector: 'app-generate-promo-success',
  templateUrl: './generate-promo-success.component.html',
  styleUrls: ['./generate-promo-success.component.scss']
})
export class GeneratePromoSuccessComponent implements OnInit {
  successJson: any = (data as any).default;
  promocode: string;
  constructor(private router: Router) {
    this.promocode = this.router.getCurrentNavigation().extras.state.promocode;
  }

  ngOnInit(): void {
  }

}
